export default __webpack_public_path__ + "static/media/icon-cicle-warning.8ad6b075.svg";